import { Pet, PetProfileFormValues, Visit } from '@app/core/models';
import { WeightFormValue } from '@app/shared/components/weight-form/weight-form';
import { Constants } from '../constants';
import { MeasureHelper } from './measure-helper';
import { MeasurementCodeType } from '../enums';

/**
 * Map pet data to profile form values
 */
export function getProfileFormValues(pet: Pet | undefined): PetProfileFormValues {
  return {
    birthdate: pet?.birth?.date || null,
    unknownBirthdate: null,
    breed: pet?.breedCode || null,
    gender: pet?.genderCode || null,
    mixed: pet?.breedCode?.startsWith(Constants.mixedBreedCode) || null,
    name: pet?.name || null,
    neutered: pet?.neutered ?? null,
    lifestage: pet?.lifeStage || null,
    reproductionStatus: pet?.reproductionStatusCode || null,
    speciesCode: pet?.speciesCode || null,
    neuteredToday: null,
    sterilizationType: null,
    pregnancyWeeks: null,
  };
}
/**
 * Map pet data to weight form values
 */
export function getWeightFormValues(
  pet: Pet | undefined,
  visit: Visit | undefined,
  currentBigMeasurementUnit: MeasurementCodeType,
  minimalBcs: number | undefined = 0,
): WeightFormValue {
  const currentWeight = visit
    ? Math.round(MeasureHelper.convertWeightToMeasure(visit.weight, currentBigMeasurementUnit) * 100) / 100
    : undefined;
  const idealBodyWeight =
    pet && visit ? Math.round(MeasureHelper.convertWeightToMeasure(pet.idealBodyWeight, currentBigMeasurementUnit) * 100) / 100 : undefined;
  const currentBcs = visit?.weight?.bcs >= minimalBcs ? visit?.weight?.bcs : minimalBcs;
  return {
    bcs: !visit?.weight?.bcs ? null : currentBcs,
    currentWeight: currentWeight || null,
    targetWeight: idealBodyWeight || null,
    ibw: idealBodyWeight || null,
    petActivity: pet?.petActivityCode || pet?.petActivity || null,
  };
}

export function getPetFromFormValues(profileFormValues: PetProfileFormValues): Pet {
  const { birthdate, breed, gender, lifestage, name, neutered, speciesCode } = profileFormValues;
  const pet: Pet = {
    birth: {
      date: birthdate,
    },
    breedCode: breed,
    genderCode: gender,
    name,
    lifeStage: lifestage,
    neutered,
    speciesCode,
  };

  return pet;
}
